
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Mail = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M2.8,4.4V20.6H19.2a3.2,3.2,0,0,0,3-3.4V4.4ZM20.7,5.9V7.5l-8.2,7.6L4.3,7.5V5.9ZM19.2,19.1H4.3V9.6l8.2,7.6,8.2-7.6v7.6A1.7,1.7,0,0,1,19.2,19.1Z"></path>
        </g>
      </g>
    </IconBase>);
};

Mail.defaultProps = {
  title: 'Mail',
};

export default Mail;
